export default __webpack_public_path__ + "static/media/settings.96a3dc7d.svg";